export const GET_EMAILS_BEGIN = 'GET_EMAILS_BEGIN'
export const GET_EMAILS_SUCCESS = 'GET_EMAILS_SUCCESS'
export const GET_EMAILS_ERROR = 'GET_EMAILS_ERROR'
